import React, { useState } from 'react';

import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';

import { Loading } from '../../common/components/Loading';
import { MVRDetailsBody } from '../detail/tasks/mvr/MVRDetailsBody';
import { factsExist } from '../detail/utilities/taskDetailUtilities';
import { Evidence } from '../tasks/types/evidence';
import { MVR } from '../tasks/types/mvr';
import { TaskTypes } from '../tasks/types/taskTypes';
import { fetchEvidenceData } from './helpers';

export const MVRDetail = ({
  product,
  carrier,
  policyId,
  evidenceId,
}: {
  product: string;
  carrier: string;
  policyId: string;
  evidenceId: number;
}) => {
  const [expanded, setExpanded] = useState(false);
  const [evidence, setEvidence] = useState<Evidence | null>(null);
  const [evidenceInprogress, setEvidenceInprogress] = useState(false);
  const [evidenceReady, setEvidenceReady] = useState(false);
  const doExpand = async () => {
    if (!expanded) {
      if (!evidenceReady && !evidenceInprogress) {
        // fetch ruleResultData
        setEvidenceInprogress(true);
        const result = await fetchEvidenceData(
          product,
          carrier,
          policyId,
          evidenceId.toString(),
          TaskTypes.MVR,
        );
        setEvidence(result);
        setEvidenceReady(true);
        setEvidenceInprogress(false);
      }
    }
    setExpanded(!expanded);
  };

  function renderTaskDetails() {
    const mvr: MVR | null = evidence ? (evidence.facts as MVR) : null;
    return (
      <MVRDetailsBody
        mvr={mvr}
        errorMessage={evidence?.errorMessage}
        evidenceId={evidenceId}
      />
    );
  }

  return (
    <Box pt={8}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        ml={-1}
      >
        <Box display="flex" flexDirection="row">
          <Box mt={-0.15} ml={-3.5} position="absolute">
            <IconButton
              style={{ width: '24px' }}
              size="small"
              onClick={doExpand}
            >
              <FontAwesomeIcon
                icon={faAngleRight}
                rotation={expanded ? 90 : undefined}
              />
            </IconButton>
          </Box>
          <Typography variant="h2">MVR</Typography>
        </Box>
      </Box>

      {expanded &&
        (evidenceInprogress ? (
          <Loading fullscreen={false} />
        ) : (
          evidenceReady &&
          (evidence ? (
            factsExist(evidence) ? (
              renderTaskDetails()
            ) : (
              <></>
            )
          ) : (
            <Box>
              <Typography variant="body1">failed to load mvr data</Typography>
            </Box>
          ))
        ))}
    </Box>
  );
};
